import Vue from 'vue'
import { ABNORMAL_MSG } from '@/const/prompt.js';
import getApiHost from './getApiHost.js';
import { logEvent, getCloudConfigByModule } from '@/apis/serviceApi.js';
import { customErrorReport, getMonitorInstance } from '@/utils/monitor'

const invitationSalt = '@@#supplment';

const sessionStorageSetItem = (name, data) => {
  sessionStorage.setItem(invitationSalt + name, JSON.stringify({ [invitationSalt + name]: data }));
};

const sessionStorageGetItem = (name) => {
  const ls = sessionStorage.getItem(invitationSalt + name);
  if (ls) {
    return JSON.parse(ls)[invitationSalt + name];
  } else {
    return undefined;
  }
};

const sessionStorageRemoveItem = (name) => {
  if (!name) {
    return;
  }
  sessionStorage.removeItem(invitationSalt + name);
};

const localStorageSetItem = (name, data) => {
  const setName = `${invitationSalt}${name}`;
  localStorage.setItem(setName, JSON.stringify({ [setName]: data }));
};

const localStorageGetItem = (name) => {
  const getName = `${invitationSalt}${name}`;
  const ls = localStorage.getItem(getName);
  if (ls) {
    return JSON.parse(ls)[getName];
  } else {
    return undefined;
  }
};

const localStorageRemoveItem = (name) => {
  if (!name) {
    return;
  }
  localStorage.removeItem(invitationSalt + name);
};

// 判断是否是Android
const isAndroid = () => {
  var info = getBrowerInfo();
  if (info.versions.android) {
    return true;
  }
  return false;
};

// 判断是否是ios
const isIOS = () => {
  var info = getBrowerInfo();
  if (info.versions.ios) {
    return true;
  }
  return false;
};

// 判断是否在微信里
const isInWeixin = () => {
  var info = getBrowerInfo();
  if (info.versions.weixin) {
    return true;
  }
  return false;
};

const getToastConst = (type) => {
  if (ABNORMAL_MSG) {
    const { NETWORK_OFFLINE, SERVER_ERROR } = ABNORMAL_MSG;
    return type === 'network' ? NETWORK_OFFLINE : SERVER_ERROR;
  }
};

const getHost = () => {
  return new Promise((resolve, reject) => {
    resolve(getApiHost());
  });
};

// 端内获取appinfo
const getAppInfo = (cb) => {
  window.AmapApp.bridge.send({ action: 'getAppInfo' }, (res) => {
    let appInfo = {};
    try {
      if (res && res.content && typeof res.content === 'string') {
        appInfo = JSON.parse(res.content);
      } else {
        appInfo = res.content;
      }
    } catch (error) {
      appInfo = {};
    }
    cb && cb(appInfo);
  });
};

// 是否在端内
const inInnerYueyue = () => {
  var info = getBrowerInfo();
  if (info.versions.innerYueyue) {
    return true;
  }
  return true;
};

// 获取浏览器信息
const getBrowerInfo = () => {
  return {
    versions: (function () {
      const u = navigator.userAgent;
      return {
        trident: u.includes('Trident'), // IE内核
        presto: u.includes('Presto'), // opera内核
        webKit: u.includes('AppleWebKit'), // 苹果、谷歌内核
        gecko: u.includes('Gecko') && !u.includes('KHTML'), // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.includes('Android') || u.includes('Adr'), // android终端
        iPhone: u.includes('iPhone'), // 是否为iPhone或者QQHD浏览器
        iPad: u.includes('iPad'), // 是否iPad
        webApp: !u.includes('Safari'), // 是否web应该程序，没有头部与底部
        weixin: u.includes('MicroMessenger'), // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === ' qq', // 是否QQ
        innerYueyue: u.includes('amap') || u.includes('YYApp'), // 是否是在约约app 中，需做兼容，以前使用 amap作为关键字
        dingTalk: u.includes('DingTalk') // 是否在钉钉中
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
};

const getExtraUrl = () => {
  const obj = {
    action: 'getExtraUrl'
  };
  return new Promise((resolve) => {
    window.AmapApp.bridge.send(obj, function (res) {
      if (res && typeof res === 'string') {
        res = JSON.parse(res);
      }
      resolve(res || {});
    });
  });
};

const trim = (s) => {
  if (s) {
    s = String(s);
    return s.replace(/(^\s*)|(\s*$)/g, '');
  } else {
    return null;
  }
};

// 端内获取用户信息
const getUserInfo = () => {
  const obj = {
    action: 'getUserInfo',
    _action: '',
    onlyGetId: 1, // 0、重新登录并返回用户信息 1、仅获取用户信息
    loginBackToPage: '', // 登录后跳转页面 如果为空 返回进入页面 如果需要跳转其他页面 需要使用其他方法 包装H5链接  方法待定，咨询怡玥
    extra: '' // 而外参数，原路返回
  };
  return new Promise((resolve) => {
    window.AmapApp.bridge.ready(() => {
      window.AmapApp.bridge.send(obj, (res) => {
        resolve(res);
      });
    });
  });
};

// 获取端内JS Bradge获取经纬度 配合高德逆地理编码获取定位信息
const getLocationByLonLat = () => {
  return new Promise(function (resolve, reject) {
    if (inInnerYueyue()) {
      const options = {
        action: 'getMapLocation'
      };
      window.AmapApp.bridge.send(options, function (result) {
        if (result.lon && result.lat) {
          const lon = result.lon;
          const lat = result.lat;
          // 根据经纬度逆地理编码
          window.AMap.plugin('AMap.Geocoder', function () {
            var geocoder = new AMap.Geocoder();

            // 经纬度数据
            const location = [lon, lat];
            geocoder.getAddress(location, function (status, result) {
              if (status === 'complete' && result.info === 'OK') {
                // result为对应的地理位置详细信息
                resolve(result.regeocode.addressComponent);
              } else {
                console.warn('根据经纬度逆地理编码失败');
              }
            });
          });
        } else {
          console.warn('定位失败');
        }
      });
    } else {
      console.warn('请在端内调用此方法');
    }
  });
};

// 使用高德获取定位
const getLocalCity = () => {
  return new Promise((resolve) => {
    if (inInnerYueyue()) {
      const obj = {
        action: 'getMapLocation'
      };
      window.AmapApp.bridge.send(obj, function (result) {
        console.log('innerYueyue, getMapLocation', result);
        if (result.adcode) {
          result.adCode = result.adcode; // 为了兼容不同版本需求。设置两个
          result.city = result.cityName; // 为了兼容不同版本需求。设置两个
          resolve(result);
        } else {
          amapGeolocation().then((res) => {
            resolve(res);
          });
        }
      });
    } else {
      amapGeolocation().then((res) => {
        resolve(res);
      });
    }
  });
};

// 使用精准定位获取定位信息
const amapGeolocation = () => {
  const map = new window.AMap.Map('map');
  return new Promise((resolve, reject) => {
    map.plugin(['AMap.Geolocation', 'AMap.CitySearch'], function (params) {
      var geolocation = new window.AMap.Geolocation();
      geolocation.getCurrentPosition(function (status, result) {
        if (status === 'complete' && result && result.addressComponent) {
          resolve({
            adCode: result.addressComponent.adcode,
            city: result.addressComponent.city || result.addressComponent.province,
            province: result.addressComponent.province,
            lon: result.position ? result.position.lng : '',
            lat: result.position ? result.position.lat : '',
            address: result.formattedAddress
          });
        } else {
          resolve({ code: -1, msg: '定位失败' });
        }
      });
    });
  });
};

const isOnLine = () => {
  return window.navigator.onLine;
};

// 判断是否是在钉钉中
const isDingTalk = () => {
  var info = getBrowerInfo();
  if (info.versions.dingTalk) {
    return true;
  } else {
    return false;
  }
};

// 兼容钉钉页面无法跟新
const setDocumentTitle = (title) => {
  document.title = title;
  if (isDingTalk()) {
    window.dd.ready(function () {
      window.dd.biz.navigation.setTitle({
        title: title
      });
    });
  }
};

// 是否端内招募
const isInnerAppRecruit = () => {
  return isInnerYueyue() && getQuery().isInnerAppRecruit;
};

const getQuery = () => {
  const result = {};
  const url = window.location.href;
  const reg1 = /([^?=&#]+)=([^?=&#]+)/g;
  const reg2 = /#([^?=&#]+)/g;
  url.replace(reg1, (n, x, y) => (result[x] = y));
  url.replace(reg2, (n, x) => (result['HASH'] = x));
  return result;
};

// 是否在端内
const isInnerYueyue = () => {
  var info = getBrowerInfo();
  console.log('info.versions.innerYueyue---', info.versions.innerYueyue);
  if (info.versions.innerYueyue) {
    return true;
  }
  return false;
};

// 埋点方法
function handleBuryPoint(pageId, clickid, ext = {}) {
  const info = JSON.parse(sessionStorage.getItem('getUserInfo') || '{}');
  const { id: driverId, mobile = '', tenantId = '' } = info || {};
  const tenantIdFormat = tenantId || getQuery()?.tenantId || 801289
  // 浏览器
  ext.useragent = window.navigator.userAgent;
  ext.driverId = driverId;
  ext.mobile = mobile;
  ext.tenantId = tenantIdFormat
  ext = JSON.stringify(ext);
  const params = {
    commonParams: {
      domainType: 200,
      terminal: 401
    },
    tenantId: tenantIdFormat,
    userId: driverId || '',
    tenantId,
    events: [
      {
        page: pageId,
        click: clickid,
        time: Date.now(),
        ext: ext
      }
    ]
  };
  logEvent(params);
}

const navigatorOnLine = (txt) => {
  const netWork = window.navigator.onLine;
  if (!netWork) {
    Toast({
      message: txt || getToastConst('network'),
      duration: 2000
    });
    return true;
  }
};

// 深拷贝
function objDeepCopy(source) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] =
      typeof source[item] === 'object' && source[item] !== null ? objDeepCopy(source[item]) : source[item];
  }
  return sourceCopy;
}

const toTel = (phoneNumber) => {
  var obj = {
    action: 'showPanellist',
    list: [
      {
        title: `拨打电话：${phoneNumber}`,
        content: phoneNumber
      }
    ]
  };
  window.AmapApp.bridge.send(obj);
};

function setCSP(cspPolicy) {
  // 查找是否已经存在 upgrade-insecure-requests meta 标签
  let upgradeMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content='upgrade-insecure-requests']"
  );
  if (!upgradeMeta) {
    // 如果没有 upgrade-insecure-requests meta 标签，创建并添加一个新的
    upgradeMeta = document.createElement('meta');
    upgradeMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    upgradeMeta.setAttribute('content', 'upgrade-insecure-requests');
    document.head.appendChild(upgradeMeta);
  }
  // 查找是否已经存在 CSP meta 标签（content 包含 default-src）
  let cspMeta = document.querySelector("meta[http-equiv='Content-Security-Policy'][content*='default-src']");
  if (cspMeta) {
    // 如果已有 CSP meta 标签，更新其 content 属性
    cspMeta.setAttribute('content', cspPolicy);
  } else {
    // 如果没有 CSP meta 标签，创建并添加一个新的
    cspMeta = document.createElement('meta');
    cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
    cspMeta.setAttribute('content', cspPolicy);
    document.head.appendChild(cspMeta);
  }
}

function removeCSP() {
  // 查找并移除 upgrade-insecure-requests meta 标签
  let upgradeMeta = document.querySelector(
    "meta[http-equiv='Content-Security-Policy'][content='upgrade-insecure-requests']"
  );
  if (upgradeMeta) {
    upgradeMeta.parentNode.removeChild(upgradeMeta);
  }

  // 查找并移除 CSP meta 标签
  let cspMeta = document.querySelector("meta[http-equiv='Content-Security-Policy'][content*='default-src']");
  if (cspMeta) {
    cspMeta.parentNode.removeChild(cspMeta);
  }
}

function isLocalhostOrIp(url) {
  // 如果 URL 没有协议部分，默认加上 http://
  try {
    const { hostname, port } = new URL(url);
    const localhostPattern = /^(localhost|127\.0\.0\.1)$/;
    const ipv4Pattern =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:\d+)?$/;
    // 如果是 localhost 或者 IP 地址，并且包含端口号，则返回 true
    return (localhostPattern.test(hostname) || ipv4Pattern.test(hostname)) && port !== '';
  } catch (e) {
    // 如果 URL 解析失败，说明它不合法
    return false;
  }
}

// 是否 测网
const isTest = () => {
  const host = window.location.host;
  return !host || host.includes('localhost') || host.indexOf('test') !== -1 || /^[0-9.:]+$/.test(host);
};

// 监控-上报接口异常
const interErrorMonitor = ({name, msg}) => {
  try {
    customErrorReport({
      name: 'warning',
      msg,
      errorType: 'monitor',
      level: 'error'
    })
  }catch(e) {
    let catchMsg = ''
    if(typeof e === 'string') {
      catchMsg = e
    } else if(typeof e === 'object') {
      catchMsg = e.message || ''
    }
    handleBuryPoint('InterErrorMonitor', 'h5-driver-ruleFunctionError', {catchMsg})
  }
}

// 初始化系统配置 CSP、monitor等
export const initSysConfig = async () => {
  const { code, data } = await getCloudConfigByModule({
    group: 'designate-passenger',
    moduleName: 'unicornStaticConfig',
    configName: 'h5BaseSwitchConfig',
    tenantId: 999
  })
  if (code === 1) {
    try {
      // h5基础开关云控 csp、monitor
      const h5baseSwitchjson = JSON.parse(data.values.h5BaseSwitchConfig)
      const projectName = 'h5-driver-rule'
      if (h5baseSwitchjson[projectName]?.csp === true) {
        handleInitCSP()
      } else {
        removeCSP()
      }
      if (h5baseSwitchjson[projectName]?.monitor === true) {
        initMonitor()
      }
    } catch (err) {
      removeCSP()
    }
  } else {
    removeCSP()
  }
}

const handleInitCSP = () => {
  const str = "default-src *; img-src data: https:; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://*.yueyuechuxing.cn https://*.longjudj.com https://*.amap.com https://*.qq.com https://unpkg.com; style-src 'self' 'unsafe-inline'; connect-src https://*.yueyuechuxing.cn https://*.longjudj.com https://*.amap.com; font-src data: https:; frame-src 'self' wvjbscheme: https:; worker-src blob:;"
  if (isLocalhostOrIp(window.location.href)) {
    removeCSP()
    return
  }
  setCSP(str)
}

const initMonitor = () => {
  console.log('🥝initMonitor____')
  getMonitorInstance({
    category: 'dj',
    appnm: 'dj-driver',
    project: 'h5-driver-rule',
    systemName: '代驾规则协议',
    Vue
  })
}

export {
  sessionStorageSetItem,
  sessionStorageGetItem,
  sessionStorageRemoveItem,
  localStorageSetItem,
  localStorageGetItem,
  localStorageRemoveItem,
  getToastConst,
  inInnerYueyue,
  getExtraUrl,
  trim,
  getHost,
  getUserInfo,
  getLocalCity,
  isAndroid,
  isIOS,
  getLocationByLonLat,
  setDocumentTitle,
  isInnerAppRecruit,
  isInnerYueyue,
  isOnLine,
  getAppInfo,
  handleBuryPoint,
  navigatorOnLine,
  objDeepCopy,
  toTel,
  isInWeixin,
  isDingTalk,
  getQuery,
  isTest,
  interErrorMonitor
};
